import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ClaimThankYou = ({ displayId, referralUrl, className = '', htmlId, ctaButtonText }) => {
  const [copied, setCopied] = useState(false);

  const shareLink = referralUrl
    ? `${window.location.origin}/p/ta-registration?agent_id=${displayId}`
    : '';


  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      id={htmlId}
      data-testid="ta-registration-form"
      className={`max-w-[1440px] mx-auto px-8 py-12 ${className}`}
    >
      <div className="max-w-[1152px]">
        <h1
          className="text-[48px] font-semibold leading-[62px] text-black mb-4"
          style={{ fontFamily: 'Poppins, sans-serif' }}
          data-testid="ta-thank-you-heading"
        >
          Thank you!
        </h1>
        <p
          className="text-[18px] font-normal leading-[28px] text-black mb-8"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          You are now signed up to be a part of Ship&Play&apos;s travel advisor registry.
        </p>

        <a
          href="/ship"
          className="inline-block px-8 py-3 text-white font-semibold text-[16px] leading-[20px]
            bg-[#252525] rounded-2xl hover:bg-[#3a3a3a] mb-10 no-underline"
          style={{ fontFamily: 'Poppins, sans-serif' }}
          data-testid="ta-book-now-button"
        >
          {ctaButtonText || 'Book now'}
        </a>

        {shareLink && (
          <div>
            <h2
              className="text-[20px] font-semibold leading-[26px] text-black mb-4"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Share with your client!
            </h2>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 text-[14px] font-normal text-[#6E6E6E]"
                style={{ fontFamily: 'Poppins, sans-serif' }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="flex-shrink-0">
                  <rect x="4" y="2" width="8" height="10" rx="1" stroke="#6E6E6E" strokeWidth="1.5"/>
                  <rect x="2" y="4" width="8" height="10" rx="1" stroke="#6E6E6E" strokeWidth="1.5" fill="white"/>
                </svg>
                <span className="truncate max-w-[400px]">{shareLink}</span>
              </div>
              <button
                type="button"
                onClick={handleCopyLink}
                data-testid="ta-copy-link-button"
                className="text-[14px] font-semibold text-black underline
                  bg-transparent border-none cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {copied ? 'Copied!' : 'Copy link'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ClaimThankYou.propTypes = {
  displayId: PropTypes.string,
  referralUrl: PropTypes.string,
  className: PropTypes.string,
  htmlId: PropTypes.string,
  ctaButtonText: PropTypes.string
};

export default ClaimThankYou;
